module.exports = __webpack_public_path__ + "img/page_recherches.53c12289.jpg";